/* global axios */

import ApiClient from '../ApiClient';
import IntegrationsAPI from '../integrations';

class WgptIntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations', { accountScoped: true, wgpt: true });
    this.integrationsAPI = IntegrationsAPI;
  }

  connectSalla(params = {}) {
    return axios.post(`${this.url}/salla/auth`, params);
  }

  updateSalla(hookData) {
    return axios.patch(`${this.url}/salla`, hookData);
  }

  updateSallaSettings(settings) {
    return axios.patch(`${this.url}/salla/settings`, settings);
  }

  getSallaOrders(contactId) {
    return axios.get(`${this.url}/salla/orders`, {
      params: { contact_id: contactId },
    });
  }

  connectZid(params = {}) {
    return axios.post(`${this.url}/zid/auth`, params);
  }

  updateZid(hookData) {
    return axios.patch(`${this.url}/zid`, hookData);
  }

  updateZidSettings(settings) {
    return axios.patch(`${this.url}/zid/settings`, settings);
  }

  getZidOrders(contactId) {
    return axios.get(`${this.url}/zid/orders`, {
      params: { contact_id: contactId },
    });
  }

  listZidWebhookSubscriptions() {
    return axios.get(`${this.url}/zid/webhooks`);
  }

  subscribeZidWebhook(eventName) {
    return axios.post(`${this.url}/zid/webhooks`, {
      event_name: eventName,
    });
  }

  unsubscribeZidWebhook(eventName) {
    return axios.delete(`${this.url}/zid/webhooks`, {
      data: { event_name: eventName },
    });
  }

  addFile(id, data) {
    return axios.post(`${this.url}/hooks/${id}/files`, data);
  }

  updateHook(hookId, hookData) {
    return axios.patch(
      `${this.integrationsAPI.baseUrl()}/integrations/hooks/${hookId}`,
      hookData
    );
  }
}

export default new WgptIntegrationsAPI();
